import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import states from '@config/states'
import CourseSearchResults from './course-search-results'

const QUERY_WORD_SEARCH = gql`
query SearchCourses($searchText: String!) {
  searchCourses(searchText: $searchText) {
    name
    photo_facility
    facility_id
    city
    state
    zip
    address1
    address2
  }
}
`
const QUERY_CITY_SEARCH = gql`
query cityCourses($stateName: String!, $city: String!) {
  cityCourses(state_name: $stateName, city: $city ) {
    name,
    facility_name,
    city,
    state,
    zip,
    address1,
    address2,
    facility_id
    photo_facility
  }
}
`

const QUERY_ZIP_SEARCH = gql`
query searchCoursesByZipCode($zipCode: String!) {
  searchCoursesByZipCode(zipCode: $zipCode) {
    name,
    facility_name,
    city,
    state,
    zip,
    address1,
    address2,
    facility_id
    photo_facility
  }
}
`

const possibleSearch = [
  { key: 'state', query: QUERY_CITY_SEARCH, response: 'cityCourses' },
  { key: 'searchText', query: QUERY_WORD_SEARCH, response: 'searchCourses' },
  { key: 'zipCode', query: QUERY_ZIP_SEARCH, response: 'searchCoursesByZipCode' },
]

export default function CourseSearchResultsWithData(props) {
  const { query } = props
  const stateName = query.state && states[query.state.toUpperCase()]
  const searchParams = possibleSearch.filter(item => Object.keys(query).includes(item.key))[0]
  const QUERY = searchParams && searchParams.query
  if (!searchParams) return <div />

  return (
    <Query query={QUERY} variables={{ ...query, stateName }} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} statusCode={404} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data[searchParams.response]
        return (
          <CourseSearchResults {...props} results={response} />
        )
      }}
    </Query>
  )
}

CourseSearchResultsWithData.propTypes = {
  query: PropTypes.shape({
    zipCode: PropTypes.string,
    searchText: PropTypes.string,
    state: PropTypes.string,
  }),
}
